__webpack_require__.p = "https://universosgamers.com.ar/wp-content/plugins/arma-tu-pc/assets/app/";